/**
 * The snapshot cells whose negative value means the plan was overrun, and the
 * warning each one shows in place of its caption. Other cells (gross profit)
 * can be negative too; they show the red accounting figure without a label.
 */
export const OVERRUN_WARNINGS: Record<
  string,
  { key: string; fallback: string }
> = {
  cost_to_complete: {
    key: "portfolio.financialSnapshot.overrun.overBudget",
    fallback: "Over Budget"
  },
  remaining_to_bill: {
    key: "portfolio.financialSnapshot.overrun.overBilled",
    fallback: "Over Billed"
  }
}

/** A cell value as a number, or null when it is not one. */
export const numericValue = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === "") return null
  const numeric = typeof value === "number" ? value : Number(value)
  return Number.isFinite(numeric) ? numeric : null
}

/** The warning a cell should show, or null when it is not overrun. */
export const overrunWarning = (
  key: string,
  value: number | string | null | undefined
) => {
  const numeric = numericValue(value)
  if (numeric === null || numeric >= 0) return null
  return OVERRUN_WARNINGS[key] ?? null
}
